import { psAxios } from '@patsnap/common-ps-http';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import jsCookie from 'js-cookie';
import _ from 'lodash';

let fingerprint = '';

export const fingerprintInterceptor = async(config) => {
    if (!fingerprint) {
        fingerprint = await getBrowserFingerprint() as unknown as string;
    }
    config.headers = _.merge({}, config.headers, {
        'X-Signature-ID': fingerprint,
        'X-Stream-Only': true, // todo（temporary）
    })
    return config;
};

/**
 * 检查是否已登录
 * 通过判断 eureka_login cookie 是否存在
 */
export const isUserLoggedIn = (): boolean => {
    const loginCookie = jsCookie.get('eureka_login');
    return loginCookie === '1';
};

/**
 * 获取fingerprint（仅在未登录时返回）
 * @returns 未登录时返回fingerprint，已登录返回空字符串
 */
export const getFingerprint = (): string => {
    if (isUserLoggedIn()) {
        return '';
    }
    return fingerprint;
};

export function injectFingerprintInterceptor() {
    if (!psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.psInterceptors.fingerprintInterceptor = psAxios.interceptors.request.use(fingerprintInterceptor, () => { });
    }
}

export function ejectFingerprintInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.fingerprintInterceptor
    );
}
